import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'

import { IRootState } from '@/@types'
import app from './modules/app'
import auth from './modules/auth'
import products from './modules/products'
import subscriptions from './modules/subscriptions'
import events from './modules/events'
import shoppingCart from './modules/shopping-cart'
import business from './modules/business'
import featureFlags from './modules/featureFlags'

Vue.use(Vuex)

const store: StoreOptions<IRootState> = {
  modules: {
    app,
    auth,
    products,
    subscriptions,
    events,
    shoppingCart,
    business,
    featureFlags,
  },
}

export default new Vuex.Store<IRootState>(store)
